import { FC } from 'react';
import { noop } from 'lodash';

import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormCheckboxValidation } from './FormCheckbox.types';
import { FormCheckboxInput } from './FormCheckboxInput/FormCheckboxInput';

interface FormCheckboxProps
  extends FormControlBaseProps<FormCheckboxValidation, boolean> {
  multiline?: boolean;
}

export const FormCheckbox: FC<FormCheckboxProps> = ({
  multiline,
  onChange: onOuterChange = noop,
  ...props
}) => {
  return (
    <FormControl variant="inline" type="checkbox" {...props}>
      {({ value = false, onBlur, onChange: onInnerChange }) => {
        return (
          <FormCheckboxInput
            value={value}
            onBlur={onBlur}
            label={props.label}
            multiline={multiline}
            onInnerChange={onInnerChange}
            onOuterChange={onOuterChange}
          />
        );
      }}
    </FormControl>
  );
};
